import React, {  useState } from "react";
import {
  Card,
  Box,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import CVEDetail from "../VendorDetail/CveSideBar.js";
import { CustomNoRowsOverlay } from "../Assessment.js";
import CustomPagination from "../../components/common/customPagination.jsx";

function CveAdmin({
  patchingRowsData
}) {
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [selectedCVE, setselectedCVE] = useState({})
  const filteredRows =
    (!patchingRowsData || !patchingRowsData.length) ? [] :
      patchingRowsData
        ?.map((val, i) => ({
          ...val,
          id: i + 1,
        }));

  const columnsNew = [
    {
      field: "id",
      headerName: "#",
      flex: 0.5,
      sortable: false,
      className: "serial-number",
      disableColumnMenu: true,
    },
    {
      field: "CVE",
      headerName: "Name",
      flex: 1.1,
      minWidth: 170, // Ensure minimum width
      disableColumnMenu: true,
    },
    {
      field: "Category",
      headerName: "Category",
      flex: 1,
      sortable: false,
      minWidth: 125,
      disableColumnMenu: true,
    },
    {
      field: "Technology",
      headerName: "Technology",
      flex: 1,
      minWidth: 100,
      disableColumnMenu: true,
      renderCell: (params) => {
        return params?.row?.ele?.Technology
      },
    },
    {
      field: "Severity",
      headerName: "Severity",
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => {
        const severity = params.row.Severity ? params.row.Severity.toLowerCase() : "";
        let scoreTag = "-";
        if (severity === 'low') {
          scoreTag = "Low";
        } else if (severity === 'medium') {
          scoreTag = "Medium";
        } else if (severity === 'critical') {
          scoreTag = "Critical";
        } else if (severity === 'high') {
          scoreTag = "High";
        }
        // if (!severity) return "Loading...";
        if (!severity) return "-";
        return (
          scoreTag ? (
            <span className={`tagClassapproval blank-white ${scoreTag}`}>
              <span>{scoreTag}</span>
            </span>
          ) : (
            "-"
          )
        );
      },
    },


  ];
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const handleRowClick = (params) => {
    setselectedCVE(params?.row)
    setOpenSidebar(true)
  };

  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  return (
    <>
      <Card className="full-coverdesign margin-questionnaire">
        <div className="cover-table">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              top: "0px",
              left: "8px",
            }}
          >
            <FormControl
              className="select-entries"
              variant="outlined"
              size="small"
            >
              <Select
                value={paginationModel.pageSize}
                onChange={(e) => handlePaginationModelChange({ page: 0, pageSize: e.target.value })}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
              </Select>
            </FormControl>
            <span className="entries-per">entries per page</span>{" "}
          </div>
          <div className="issues-tab-table">
            <Box
              sx={{
                width: "100%",
                "& .MuiDataGrid-columnHeaders": {
                  minWidth: "100%",
                  overflowX: "hidden",
                },
                "& .MuiDataGrid-virtualScroller": {
                  minWidth: "100%",
                  overflowX: "auto",
                },
              }}
            >

              <DataGrid
                // loading={showLoader}
                rows={filteredRows}
                columns={columnsNew}                
                rowHeight={70}                
                onPaginationModelChange={handlePaginationModelChange}
                paginationModel={paginationModel}                              
                pageSizeOptions={[5, 10, 25]}
                slots={{
                  toolbar: GridToolbar,
                  noRowsOverlay: CustomNoRowsOverlay,
                  pagination: CustomPagination,
                }}
                slotProps={{
                  pagination: {
                    paginationModel,
                    onPaginationModelChange: handlePaginationModelChange,
                    rowCount: filteredRows?.length
                  },
                }}
                disableRowSelectionOnClick
                disableColumnFilter
                disableColumnSelector
                disableDensitySelector
                disableColumnMenu
                paginationMode="client"
                disableSelectionOnClick
                autoHeight
                className="datagrid-table"
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    minWidth: "100%", // Column headers take up full width
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    minWidth: "100%", // Rows take up full width
                  },
                }}
                onRowClick={handleRowClick}
              />
            </Box>
          </div>
        </div>
      </Card>
      {openSidebar &&
        <CVEDetail
          handleClose={() => setOpenSidebar(false)}
          open={openSidebar}
          cveData={selectedCVE}
        />
      }
    </>
  );
}

export default CveAdmin;
